import React from 'react';

import Heading from '@atlaskit/heading';
import SectionMessage from '@atlaskit/section-message';

import ShowSidebarToggle from 'src/views/ProjectSettings/components/ShowSidebarToggle';

const ProjectSettings = () => {
  return (
    <div>
      <Heading size="medium">PagerDuty integration</Heading>
      <br/>
      <ShowSidebarToggle/>
      <br/>
      <SectionMessage>
        Other settings can be accessed in the administrator settings of the PagerDuty app page.
      </SectionMessage>
    </div>
  );
};

export default ProjectSettings;
